window.$ = window.jQuery = require('jquery');
require('./common.js');
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';

// Constants
const SLIDER_PAGINATION_DOT = 'DOT';
const SLIDER_PAGINATION_NUMBER = 'NUMBER';
const SLIDER_PAGINATION_DASH = 'DASH';

// Get the current URL
let currentURL = new URL(window.location.href);
// Get the path segments
let pathSegments = currentURL.pathname.split('/');

jQuery(function () {

   var $lpLoadingScreen = $("#loading-overlay");
   if ($lpLoadingScreen.length) {
      $(window).on('load', function() {
         $lpLoadingScreen.hide();
      });
   }

   function initializeSliderSections(sliderConfigArr) { 
      // Validate sliderSectionConfigs
      if (!Array.isArray(sliderConfigArr) || sliderConfigArr === 0) {
         return;
      }
      
      // Initialize each slider section
      sliderConfigArr.forEach(function(section, index) {
         
         const sectionElem = $(`.theme-slider-section-${index}`);

         // Update section visibility
         if(section.hideSection) {
            sectionElem.hide();
         } else {
            sectionElem.show();
         }

         // Update background details
         const bgColor = section.backgroundColor ? hexToRGBA(section.backgroundColor, section.backgroundOpacity) : null;
         const backgroundImage = section.backgroundImage && section.backgroundImage != '#' ? `url("${section.backgroundImage}")` : null;

         const backgroundStyle = bgColor && backgroundImage ? `linear-gradient(${bgColor}, ${bgColor}), ${backgroundImage}` :
                                 bgColor ? `linear-gradient(${bgColor}, ${bgColor})` :
                                 backgroundImage ? backgroundImage : null;

         if (backgroundStyle) {
            sectionElem.css('background', backgroundStyle);
         }

         let sliderElem = sectionElem.find('.slideshow-container');
         if (!sliderElem.parent().hasClass('container')) {
            sliderElem.wrap('<div class="container"></div>');
         }
         sectionElem.find(`#theme-slider-title-${index}`).html(section.title || '');
         // Clear and rebuild slider content
         sliderElem.removeClass('slideshow-dot slick-initialized slick-slider slick-dotted slick-numbered slick-dashed').html('');

         // Destroy existing slider if it exists
         if (sliderElem.hasClass('slick-initialized')) {
            sliderElem.slick('destroy');
         }

         // Handle grid layout container
         if (section.layoutType === 'GRID') {
            sectionElem.addClass('slider-grid-view');
         } else {
            sectionElem.removeClass('slider-grid-view');
         }

         // Clear and rebuild slider content
         sliderElem.html('');

         // Add slides
         section.slides.forEach((slide, slideIndex) => {
            if(!slide.hideSlide)
            {
              const slideHTML = generateSlideHTML(section, slide, slideIndex);
              sliderElem.append(slideHTML);
            }
          });
          
          const paginationStyle = section?.paginationStyle ?? SLIDER_PAGINATION_DOT;
          let   slidesToShow    = 1;
          let   dots            = true;
          let   mobileLayout    = false;

          // Template Options
          if(section.templateId == 1)
          {
            slidesToShow = 3;
            dots = false;
            mobileLayout = true;
          }

          let slickOptions = {
            slidesToShow,
            dots,
            arrows: true,
            autoplay: (section?.changeSliderEvery > 0) ? section?.autoRotate : false,
            infinite: true,
            autoplaySpeed: (section?.changeSliderEvery ?? 3000) * 1000, // Convert seconds to milliseconds
            responsive : mobileLayout ? [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: true,
                  dots
                }
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ] : false,
          };

          // Only add customPaging if not using DOT style
          if (paginationStyle !== SLIDER_PAGINATION_DOT) {
            if (paginationStyle === SLIDER_PAGINATION_NUMBER) {
              slickOptions.dotsClass = 'slick-dots slick-numbered';
            } else if (paginationStyle === SLIDER_PAGINATION_DASH) {
              slickOptions.dotsClass = 'slick-dots slick-dashed';
            }
          }

         sliderElem.slick(slickOptions);
      });
   }

   function sanitizeHtmlForAttribute(html) {
      if (!html) return '';
      
      return String(html)
        .replace(/[&"'`<>\n\r\t]/g, '')
        .trim();
   }

   function generateSlideHTML(section, slide, index) {
      let slideContent = '';
      let mobileClass = '';
      if(section.templateId != 1){
         mobileClass  = section.showContentBelowSlideOnMobile ? 'slideshow-mobile-content-below' : '';
      }
      
      if (slide.slideType === 'image-slide') {
        slideContent = `<img src="${slide.image}" alt="${sanitizeHtmlForAttribute(slide.title)}">`;
      } else if (slide.slideType === 'video-slide') {
        slideContent = `
          <video muted ${slide.autoplay ? 'autoplay' : ''} ${slide.loop ? 'loop' : ''}>
            <source src="${slide.video}" type="video/mp4">
            <span>${slide.title}</span>
          </video>`;
      } else if (slide.slideType === 'embed-slide') {
        var embedUrl =  '';
        // Add validation for embed URL
        if (slide.embedUrl) {
            // Check if URL contains either YouTube embed paths
            const isValidEmbed = slide.embedUrl.includes('youtube.com/embed/');
            
            if (!isValidEmbed) {
               showSwal('error', trans('landingpage.customize.slider.slide.embeded.url.validation.fail'));
               slide.embedUrl = ''; // Clear invalid URL
               return;
            }

            embedUrl = slide.embedUrl.trim(); // Trim whitespace to avoid URL errors

            // Add autoplay and mute parameters to embed URLs while preserving existing parameters
            if (embedUrl.includes('youtube.com/embed/')) {
               var youtubeSrc = $(embedUrl).attr('src');

               youtubeSrc += `&autoplay=1&mute=1&controls=0`;
               embedUrl = `<iframe 
                 src="${youtubeSrc}" 
                 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                 allowfullscreen
                 frameborder="0"
                 title="video player"
               ></iframe>`;
            }
        }
        // Generate the HTML content for the video
        slideContent = `
            <div class="video-inner">
              <div class="embed-container">
                ${embedUrl}
              </div>
            </div>`;
      }

      const rgba = hexToRGBA(slide.overlayColor, slide.overlayOpacity);
      let linkUrl = slide.link;
      if (linkUrl && linkUrl !== 'javascript:void(0)' && linkUrl !== '#' && linkUrl.indexOf('http://') !== 0 && linkUrl.indexOf('https://') !== 0) {
        linkUrl = 'https://' + linkUrl;
      }

      if(linkUrl == '#'){
        linkUrl = 'javascript:void(0)';
      }
                
      return `<div class="slideshow-slide ${slide.contentPosition}" data-index="${index}" ${slide.hideSlide ? 'style="display: none;"' : ''} >
          ${slideContent}
          <div class="slideshow-content-layer ${mobileClass}" style="background: linear-gradient(${rgba}, ${rgba});">
            <div class="slideshow-content ${slide.contentAlignment}">
              ${slide.heading ? `<h2>${slide.heading}</h2>` : ''}
              ${slide.description ? `<p>${slide.description}</p>` : ''}
              ${slide.showButton ? `
                <a href="${linkUrl}" class="btn-theme">
                  ${slide.linkLabel}
                </a>
              ` : ''}
            </div>
          </div>
        </div>`;
    }

   function hexToRGBA(hex, alpha) {
      // Remove the hash if present
      hex = hex.replace('#', '');
      
      // Parse the hex values
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      
      // Return the rgba string
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
   }

   //Language Switcher Toggle on load
   function toggleNavbarLanguage(lang)
   {
      let  tabsElem = $(".lp-language-switcher-tabs");
      let  selectedLangButton = tabsElem.find(`[data-lang="${lang}"]`);    
      let  selectedLangTitle = selectedLangButton.text();

      if(tabsElem.hasClass('is-updated')) {
         return;
      }

      var moreIcon = '';
      if($(".fe-language-switcher:not(.lp-language-switcher a:first)").length > 0)
      {
         moreIcon = '<i class="fa fa-chevron-down" aria-hidden="true"></i>';
      }

      $(".lp-language-switcher a:first").html(selectedLangTitle + moreIcon);
      selectedLangButton.remove();
      tabsElem.addClass('is-updated');
   }

   function updateFooterRelatedChanges() {

      //Update Footer Powered by Icon
      var poweredByBtn = $('.theme-social-section').next('a');
      //Change icon if it's old
      var currentUrl = poweredByBtn.find('img').attr('src');
      var oldLogoUrl = 'poweredby-vfairs.png';
      var newLogoUrl = 'powered-by-vfairs.png';
      
      if(typeof currentUrl !== 'undefined' && currentUrl.substring(currentUrl.lastIndexOf('/') + 1) == oldLogoUrl)
      {
        let updatedLogoUrl = currentUrl.substring(0, currentUrl.lastIndexOf('/'))+`/${newLogoUrl}`;
        poweredByBtn.find('img').attr('src', updatedLogoUrl);
      }
   }

   // Code For front-end only 
   if (Array.isArray(pathSegments) && pathSegments.length > 1 && pathSegments[1] !== 'backend') {
      const currentPageID = $(".current-page-id").val();
      const pageSliderConfig = currentPageID ? window['pageSliderConfig' + currentPageID] : window.sliderSectionConfigs;
      if (pageSliderConfig) {
         initializeSliderSections(pageSliderConfig);
      }
   }
   // Slick Slider JS Ends Here

   //Call Functions Here
   updateFooterRelatedChanges();

   $(document).ready(function(){

      var theme_primary_color = $('.theme-color-primary').val();
      var theme_secendory_color = $('.theme-color-secendory').val();
      var theme_text_color = $('.theme-color-text').val();

      $('#LoginModal .modal-header').css('background', theme_primary_color);
      $('#LoginModal .btn-darkgrey').css('background', theme_secendory_color);
      $('#LoginModal .btn-default').css('background', theme_secendory_color);

      $('.lp-template3').siblings('.header-content').addClass('lp-template3-header');

      var header_height = $('.lp-nav-header').height() -5;
      var header_height_px = (header_height+5)+ 'px';
      var double_header_height_px = (header_height*3)/2+'px';
      $('.registration-form .full-page-container').css('margin-top', double_header_height_px);
      $('.page_break_form').not('.inner-template-html *').parents('.full-page-container').css('margin-top', double_header_height_px);
      $('.privacy-policy .full-page-container').css('margin-top', double_header_height_px);
      $('.terms-of-service .full-page-container').css('margin-top', double_header_height_px);
      $('.reg-form-data').not('.inner-template-html *').parents('.full-page-container').css('margin-bottom', header_height_px);
      $('div#top').attr("style", "height: 0; overflow: hidden");    
      $('.main_top_area').css('margin-top', 0);
      $('.inner-template-html').css('margin-top', 0);
      $('.lp-template-wrap').css('margin-top', 0);
      $('.lp-template-wrap .theme-hero-section').css('margin-top', '-' + header_height_px);
      $('.lp-template-wrap.full-size-banner .theme-hero-section').css('margin-top', 0);

      $('.header-content.sticky.header-static').parents('.header-content').addClass('header-static');
      $('.lp-nav-header').parent().toggleClass('lp-nav-full-banner', $('.lp-template-wrap').hasClass('full-size-banner'));

      try {
         // Function to play video if it has autoplay enabled using jQuery
         function playAutoplayVideos(selector) {
            const elements = document.querySelectorAll(selector);
            elements.forEach(element => {
               if (element.hasAttribute('autoplay')) {
                  element.muted = true;
                  element.play();
               }
            });
         }

         // Play videos for different selectors
         playAutoplayVideos('#theme-hero-video-elm, .theme-image-video-elm, #theme-video-elm, .theme-custom-video-elm');
         
      } catch (error) {
          console.error("An error occurred:", error.message);
      }

      $('.container-parent').find('.header-content').addClass('solid-header-color');
      var lpScrollTop = 100;
      $(window).bind('scroll', function () {
          if ($(window).scrollTop() > lpScrollTop) {
              $('.stickyNavBg').addClass('stickyNavBgNavBgColor');
          } else {
              $('.stickyNavBg').removeClass('stickyNavBgNavBgColor');
          }
      });

      if (pathSegments.length <= 2 || pathSegments[1] !== 'backend') {
         var scriptSrc = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.min.js';
         var script = $('script[src="' + scriptSrc + '"]');

         if (script.length) {
             console.log("Script found:");
         } else {
            $('#navbarSupportedContent').removeClass('show');
            $(document).off('click', '.navbar-toggler').on('click', '.navbar-toggler', function (e) {
               $(this).siblings('#navbarSupportedContent').toggleClass('show');
            })

            $('.theme-faq-list .accordion-item').find('.accordion-collapse').removeClass('show');
            $('.theme-faq-list .accordion-item:first-child').find('.accordion-collapse').show();
            $('.theme-faq-list .accordion-item').find('.accordion-button').addClass('collapsed');
            $('.theme-faq-list .accordion-item:first-child').find('.accordion-button').removeClass('collapsed');
            $(document).off('click', '.theme-faq-list .accordion-item .accordion-header').on('click', '.theme-faq-list .accordion-item .accordion-header', function(e){
               e.preventDefault(); // Prevent any default behavior
                              
               const $currentItem = $(this);
               const $currentCollapse = $currentItem.siblings('.accordion-collapse');
               const isCurrentlyOpen = $currentCollapse.is(':visible');
               
               // Close all other panels
               $('.theme-faq-list .accordion-item .accordion-collapse').slideUp();
               $('.theme-faq-list .accordion-item .accordion-button').addClass('collapsed');
               
               // Toggle current panel
               if (!isCurrentlyOpen) {
                  $currentCollapse.slideDown();
                  $currentItem.find('.accordion-button').removeClass('collapsed');
               }
            });
         }
      }

      var image = new Image();
      let bnrImgSrc = $('.hero-banner-img').attr('src');
      image.src = bnrImgSrc;
      image.onload = function () {
         let bnrImgHeight = $('.hero-banner-img').height();
         let bnrImgHeightPx = bnrImgHeight+'px';
         $('.main_top_area').css('min-height', bnrImgHeightPx);
         $('.hero-banner-wrap').css('min-height', bnrImgHeightPx);
      }
      image.onerror = function () {
         console.error("Cannot load image");
      }

      $(window).resize(function(){
         let bnrImgHeight = $('.hero-banner-img').height();
         let bnrImgHeightPx = bnrImgHeight+'px';
         $('.main_top_area').css('min-height', bnrImgHeightPx);
         $('.hero-banner-wrap').css('min-height', bnrImgHeightPx);
      });

   })
   
   // Check if the second segment exists and is not backend
   if (pathSegments.length >= 3 && pathSegments[2]) {
      const firstSegment = pathSegments[1];
      const secondSegment = pathSegments[2];

      if(firstSegment !== 'backend')
      {
         const tempPageArr = secondSegment.split('-'); 
         if(tempPageArr.length > 0 && tempPageArr[0])
         {
            //Show Buttons for all type here        
         }
      }
   }

   //Language Switcher
   if(pathSegments[1])
   {
      const selectedLangPrefix = pathSegments[1];
      toggleNavbarLanguage(selectedLangPrefix);
      
   }else{//we don't really need this but just in case
      const defaultLanguagePrefix = $(".default-language-prefix").val();
      toggleNavbarLanguage(defaultLanguagePrefix); 
   }

   //For Home page only
   if (pathSegments.length <= 3)
   {
      const firstSegment = pathSegments[1];
      const secondSegment = pathSegments[2];
      if(firstSegment !== 'backend')
      {
         const tempPageArr = (secondSegment) ? secondSegment.split('-').length : 0; 
         if(tempPageArr >= 1)
         {
            //Hide Social Share Buttons from all sub pages 
            $(".st-sticky-share-buttons").hide();
         }
      }
   }
   //Hide Extra Buttons Ends Here

   //Language Switcher
   $(document).off('click', '.fe-language-switcher').on('click', '.fe-language-switcher', function (e) {
      e.preventDefault();
      var languagePrefix = $(this).attr('data-lang');
      var thirdSegment   = '/';
      var baseURL        = window.location.protocol + "//" + window.location.host+"/";

      // Check if the second segment exists
      if (pathSegments.length >= 3 && pathSegments[2]) {
         thirdSegment += pathSegments[2];
      }

      window.location.href  = baseURL + languagePrefix + thirdSegment;
   });

   $(document).off('click', '.fe-links').on('click', '.fe-links', function (e) {
      if (!(Array.isArray(pathSegments) && pathSegments.length > 1 && pathSegments[1] !== 'backend')) {
         return false;
      }
      
      e.preventDefault();
      
      if($(this).hasClass('lp-dropdown-link')){
         return;
      }

      var pageLink = $(this).attr('data-link');
      var pageType = $(this).attr('data-page-type');
      var hasCustomPage = $(this).attr('data-page-id');
      const firstSegment = pathSegments[1];
      var languagePrefix = '';
      var baseURL        = window.location.protocol + "//" + window.location.host+"/";

      if(pageType != "HOME")
      {
         languagePrefix = ($('.default-language-prefix').length > 0) ? $(".default-language-prefix").val()+"/" : 'en/';
      }

      if(hasCustomPage)
      {
         pageLink = $(this).attr('href') || pageLink;
      }

      // Check if the second segment exists
      if (pathSegments.length >= 2 && pathSegments[1] && firstSegment != 'backend') {
         languagePrefix = pathSegments[1]+"/";
      }


      if(firstSegment === 'backend')
      {
         languagePrefix = ($('.default-language-prefix').length > 0) ? "/"+$(".default-language-prefix").val()+"/" : '/en/';
         baseURL = customizeComponent.siteUrl;

         // Check if baseURL contains "http://" or "https://"
         if (!baseURL.includes("http://") && !baseURL.includes("https://")) {
            // If not, add "https://"
            baseURL = "https://" + baseURL;
         } else if (baseURL.includes("http://")) {
            // If contains "http://", replace with "https://"
            baseURL = "https://" + baseURL.slice(7);
         }
      }

      window.location.href  = baseURL + languagePrefix + pageLink;
   });

   // Gallery Section JS Starts //
      $(document).off('click', '.open-gallery-item').on("click", '.open-gallery-item', function() {
         var modalIndex = $(this).attr('data-index');
         $('#gallery-lightboxModal-' + modalIndex).css('display', 'block');
         var galleryItemId = $(this).attr('gallery-item-id');
         showGalleryItem(galleryItemId, modalIndex);
      });

      $(document).off('click', '.close-gallery-lightboxModal').on("click", '.close-gallery-lightboxModal', function() {
         var modalIndex = $(this).attr('data-index');
         var modal = $('#gallery-lightboxModal-' + modalIndex);
      
         modal.find("video").each(function() {
            var video = this;
            video.pause();
            video.currentTime = 0;
         });

      modal.find("iframe").each(function() {
         var iframe = this;
         if (iframe.src.includes("youtube.com") || iframe.src.includes("canva.com")) {
            iframe.src = iframe.src;
         }
      });

         $('#gallery-lightboxModal-' + modalIndex).css('display', 'none');
      });

      $(document).off('click', '.next-gallery-lightboxModal').on("click", '.next-gallery-lightboxModal', function() {
         var modalIndex = $(this).attr('data-index');
         var currentItem = $('#gallery-lightboxModal-' + modalIndex).find(".gallery-item-slides:visible");
         var nextItem = currentItem.next(".gallery-item-slides");

         if (!nextItem.length) {
            nextItem = $('#gallery-lightboxModal-' + modalIndex).find(".gallery-item-slides").first(); // Loop to the first item
         }

         var galleryItemId = nextItem.attr('gallery-item-id');
         showGalleryItem(galleryItemId, modalIndex);
      });

      $(document).off('click', '.prev-gallery-lightboxModal').on("click", '.prev-gallery-lightboxModal', function() {
         var modalIndex = $(this).attr('data-index');
         var currentItem = $('#gallery-lightboxModal-' + modalIndex).find(".gallery-item-slides:visible");
         var prevItem = currentItem.prev(".gallery-item-slides");

         if (!prevItem.length) {
            prevItem = $('#gallery-lightboxModal-' + modalIndex).find(".gallery-item-slides").last(); // Loop to the last item
         }

         var galleryItemId = prevItem.attr('gallery-item-id');
         showGalleryItem(galleryItemId, modalIndex);
      });

      function showGalleryItem(galleryItemId, modalIndex) {
         var gallerySlides = $('#gallery-lightboxModal-' + modalIndex).find(".gallery-item-slides");

         // Hide all slides and reset media
         gallerySlides.hide().each(function() {
            var video = $(this).find("video")[0];
            if (video) {
               video.pause();
               video.currentTime = 0;
            }

         var iframe = $(this).find("iframe")[0];
         if (iframe && (iframe.src.includes("youtube.com") || iframe.src.includes("canva.com"))) {
            iframe.src = iframe.src; // Reset YouTube iframe
         }
      });

         var currentSlide = $('#gallery-lightboxModal-' + modalIndex).find(".gallery-item-slides[gallery-item-id='" + galleryItemId + "']").show();

         var video = currentSlide.find("video")[0];
         if (video) {
            video.play();
         }
      }
   // Gallery Section JS Ends //

   // Multicolumn text animation
   $('.multicolumn-layout-2 .multicolumn-item-inner .multicolumn-column-title, .multicolumn-layout-4 .multicolumn-item-inner .multicolumn-column-title').each(function () {
       var characters = $(this).text().split(""); 
       var $this = $(this);
       $this.empty();

       $.each(characters, function (i, el) {
           if (el === " ") {
               $this.append('<span class="letter-' + i + '">&nbsp;</span>');
           } else {
               $this.append('<span class="letter-' + i + '">' + el + '</span>');
           }
       });
   });
   function reveal() {
       $(".multicolumn-layout-2 .multicolumn-item-inner .multicolumn-column-title, .multicolumn-layout-4 .multicolumn-item-inner .multicolumn-column-title").each(function () {
           var windowHeight = window.innerHeight;
           var elementTop = this.getBoundingClientRect().top;
           var elementBottom = this.getBoundingClientRect().bottom;
           var elementVisible = 50;
           
           // Check if element is within the viewport
           if ((elementTop < windowHeight - elementVisible) && (elementBottom > elementVisible)) {
               let spans = $(this).find("span");

               // Avoid resetting the animation on every small scroll
               if (!$(this).hasClass("animated")) {
                   $(this).addClass("animated");

                   spans.each(function (i) {
                       setTimeout(() => {
                           $(this).addClass("textAnimateIn");
                       }, i * 50); // Delay each letter animation (50ms per letter)
                   });
               }
           } else {
               // Remove animation class only when element is fully out of viewport
               if (elementTop > windowHeight || elementBottom < 0) {
                   $(this).removeClass("animated");
                   $(this).find("span").removeClass("textAnimateIn");
               }
           }
       });
   }

   // Run reveal on scroll
   window.addEventListener("scroll", reveal);
   reveal();
   // Multicolumn text animation End //

   // Sponsors Section JS Starts //
      function initializeSponsorsSection()
      {
         if($('.sponsors-template-2').length > 0)
         {
            $('.sponsors-template-2').slick({
               slidesToShow: 4,
               slidesToScroll: 1,
               autoplay:true,
               infinite: true,
               autoplaySpeed: 5000,
               dots: false,
               arrows: false,
               responsive: false
            });
         }
      }

      initializeSponsorsSection();
   // Sponsors Section JS Ends //

 })

